import { MY_CLUB_SETTINGS_PAGE } from 'constants/pages';
import {
  BookingConnectionStatusesEnum,
  BookingIntegrationStatusesEnum,
  useGetVenueBookingIntegrationQuery,
} from 'types/generated/client';
import InfoAlert from 'components/InfoAlert';
import Link from 'components/Link';

interface Props {
  venueId: string;
}

/** Onboarding can be done while the engine has not yet signed in as the booking account; say so. */
export default function BookingConnectionAlert({ venueId }: Props) {
  const { data } = useGetVenueBookingIntegrationQuery({
    variables: { venueId },
    skip: !venueId,
    fetchPolicy: 'cache-and-network',
  });
  const integration = data?.venueBookingIntegrations[0];
  if (!integration || integration.status !== BookingIntegrationStatusesEnum.Active) {
    return null;
  }

  if (integration.connectionStatus === BookingConnectionStatusesEnum.Failed) {
    return (
      <InfoAlert
        variant="error"
        title="We couldn't sign in with the booking account"
        desc={`Court bookings are paused. Check that ${integration.bookingAccountEmail} is an active member on your booking system and its password hasn't changed, then let us know so we can retry.`}
      >
        <Link href={MY_CLUB_SETTINGS_PAGE} className="typography-product-link text-color-error">
          Review booking settings
        </Link>
      </InfoAlert>
    );
  }

  if (integration.connectionStatus !== BookingConnectionStatusesEnum.Verified) {
    return (
      <InfoAlert
        variant="info"
        title="We're connecting your booking account"
        desc={`Our team is finishing the ${integration.bookingAccountEmail} membership on your booking system and confirming it can reserve courts. Bookings open as soon as that's done.`}
      />
    );
  }

  return null;
}
